import React, { Component } from 'react';

import './App.css';
import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom';

// import Switch from 'react-router-dom/Switch.jsx';
import Navbar from './Components/Navbar.jsx';

import QueryRoute from './Components/QueryRoute';
import NotFound from './Components/NotFound';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title"><span className="highlight">Noah's</span><span className="writing">Landing Page Goodies</span></h1>
          <p>A collection of marketer-friendly solutions that will help power up your landing pages.</p>
        </header>
        <BrowserRouter>
          <div className="container">
            <Navbar />
            <Switch>
              <Route exact path={`/`} component={QueryRoute} />
              <Route exact path={`/:query`} component={QueryRoute} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js